import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-social-connect-info",
    templateUrl: "./social-connect-info.component.html",
    styleUrls: ["./social-connect-info.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class SocialConnectInfoComponent implements OnInit {
  constructor(
    private connectDialong: MatDialogRef<SocialConnectInfoComponent>,
    private GTMSegment: GTMSegmentService,
  ) {
    this.GTMSegment.GTMPopupInitialization("SocialConnectInfo");
  }

  ngOnInit() { }

  connect() {
    this.connectDialong.close(true);
  }
}
